import { ENUM__component_type } from '@/enums/ENUM__component_type';
import { use_effect } from '@/hooks/_base/use_effect';
import { HOOK__notifier } from '@/hooks/HOOK__notifier';
import { use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { Draggable } from '@hello-pangea/dnd';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { ENUM__token_type } from '@shared/dto/generation/graph_invoke/_fields/token/ENUM__token_type';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { useState } from 'react';
import { G_UI_FIELD__overlay_not_used } from '../../_base/G_UI_FIELD__overlay_not_used';
import { G_UI_FIELD_PRIMITIVE__number } from '../../primitive_number/G_UI_FIELD_PRIMITIVE__number';
import { G_UI_FIELD__token_list_item_header } from './G_UI_FIELD__token_list_item_header';
import { G_UI_FIELD__token_list_item_text_area } from './G_UI_FIELD__token_list_item_text_area';
import { HOOK__token_drag_is_disabled } from './HOOK__token_drag_is_disabled';

interface Props {
  field: FIELD__token;
  field_parent: FIELD__list_token;
  index: number;
}

export function G_UI_FIELD__token_list_item({ field, field_parent, index }: Props) {
  /*
   * STORE
   */
  const { g_grid2d__token_edit } = use_slice_ui(['g_grid2d__token_edit']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  /*
   * STATE
   */

  const component_id = `${ENUM__component_type.PAGE_GENERATION_TOKEN_BAR}_${field.meta.field_id}`;
  const notifier = HOOK__notifier(component_id, ENUM__workspace_entity.ENTITY_GENERATION);

  const is_edit_mode = g_grid2d__token_edit.meta.field_id == field.meta.field_id;

  /*
   * STATE
   */

  const [is_mouse_hovered, set_is_mouse_hovered] = useState(false);

  const is_drag_disabled = HOOK__token_drag_is_disabled(field_parent);
  /*
   * EVENTS
   */

  function onMouseMove(event: MouseEvent) {
    const element = document.elementFromPoint(event.clientX, event.clientY);
    if (!element) {
      set_is_mouse_hovered(false);
    } else if (element.closest(`[data-token-id="${field.meta.field_id}"]`)) {
      set_is_mouse_hovered(true);
    } else {
      set_is_mouse_hovered(false);
    }
  }

  /*
   * EFFECTS
   */
  //we use event onMouseMove to fix bug when over token is not switches back
  use_effect(() => {
    document.addEventListener('mousemove', onMouseMove);

    return () => void document.removeEventListener('mousemove', onMouseMove);
  }, [field]);

  /*
   *
   */

  /*
   * HTML
   */

  return (
    <Draggable isDragDisabled={is_drag_disabled} draggableId={field.meta.field_id} {...{ index }}>
      {provided => (
        <div
          data-token-id={field.meta.field_id}
          ref={provided.innerRef}
          {...provided.draggableProps}
          className={`relative flex flex-col w-full 
            transition-opacity transition-transform
            `}
        >
          {!is_edit_mode && (
            <G_UI_FIELD__token_list_item_header {...{ field, field_parent }} {...{ is_mouse_hovered }} dragHandleProps={provided.dragHandleProps} />
          )}
          {!is_edit_mode && field.type != ENUM__token_type.EMBEDDING && <G_UI_FIELD_PRIMITIVE__number field={field.weight} without_header />}
          {is_edit_mode && <G_UI_FIELD__token_list_item_text_area {...{ field, field_parent }} />}
          <G_UI_FIELD__overlay_not_used {...{ field }} is_visible={!is_mouse_hovered} class_name_wrapper="" />
        </div>
      )}
    </Draggable>
  );
}
